declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
    __gaBootstrapped__?: boolean;
    __gaInitialized__?: boolean;
  }
}

const GA_ID = process.env.GATSBY_GA_MEASUREMENT_ID; // <- uses your Netlify env

export const bootstrapGA = () => {
  if (typeof window === "undefined" || !GA_ID) return;
  if (window.__gaBootstrapped__) return;
  window.__gaBootstrapped__ = true;

  // 1️⃣  Stub dataLayer + gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    (window.dataLayer as any).push(arguments);
  }
  window.gtag = gtag;

  // 2️⃣  Default consent: fully denied
  gtag("consent", "default", {
    ad_storage: "denied",
    analytics_storage: "denied",
    functionality_storage: "denied",
    personalization_storage: "denied",
    security_storage: "granted",
  });

  // 3️⃣  Load GA4 script
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.onload = () => {
    console.log("[GA4] GA script loaded");
    // Minimal init in denied mode (no hits sent)
    gtag("js", new Date());
    gtag("config", GA_ID, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      anonymize_ip: true,
    });
    console.log(`[GA4] Bootstrapped in denied mode (${GA_ID})`);
  };
  document.head.appendChild(script);
};

export const enableGA = () => {
  if (typeof window === "undefined") return;
  if (!GA_ID) {
    console.warn("GA - missing GA_ID");
    return;
  }

  // 1️⃣  Tell GA that the user has granted consent
  if (typeof (window as any).gtag === "function") {
    (window as any).gtag("consent", "update", {
      ad_storage: "granted",
      analytics_storage: "granted",
      functionality_storage: "granted",
      personalization_storage: "granted",
    });
    console.log("[GA4] Consent updated → granted");
  } else {
    console.warn("[GA4] gtag not yet defined when enabling GA");
  }

  // 2️⃣  Optionally configure GA again (safe even if already done)
  (window as any).gtag("config", GA_ID, {
    anonymize_ip: true,
    send_page_view: false,
  });

  // 3️⃣  Mark as initialized and notify listeners
  (window as any).__gaInitialized__ = true;
  window.dispatchEvent(new Event("ga-ready"));
  console.log(`GA - setup completed with ${GA_ID}`);
};

export function sendGAEvent(eventName: string, params: Record<string, any>) {
  return
  if (typeof window === "undefined") return;

  const gtag = (window as any).gtag;
  const isReady = !!(window as any).__gaInitialized__;

  if (!isReady) {
    console.log(`[GA4] delaying ${eventName} until GA init`);
    // Queue the event and resend when GA becomes ready
    window.addEventListener("ga-ready", () => {
      const readyGtag = (window as any).gtag;
      if (typeof readyGtag === "function") {
        readyGtag("event", eventName, params);
        console.log(`[GA4] sent delayed ${eventName} after GA init`, params);
      }
    }, { once: true });
    return;
  }

  if (typeof gtag === "function") {
    gtag("event", eventName, params);
    console.log(`[GA4] ${eventName}`, params);
  }
}

export function sendSectionView(sectionName: string, triggerType: "direct" | "link" | "scroll") {
  sendGAEvent("section_view", {
    section_name: sectionName,
    trigger_type: triggerType,
    page_location: window.location.href,
  });
}

export function sendClickEvent(
  element_name: string,
  element_location: string,
  context?: Record<string, any>
) {
  sendGAEvent("ui_click", {
    element_name,           // e.g. "get_started_nav"
    element_location,       // e.g. "navbar"
    ...context,             // optional context, e.g. { plan_name: "premium" }
    page_location: window.location.href,
  });
}

export {};
